// extracted by css-extract-rspack-plugin
export default {"search_opened":"rAqDh","searchOpened":"rAqDh","resultsAnchor":"jZeXP","close_btn":"DAc_z","closeBtn":"DAc_z","search":"oHJ6F","search_input":"yft3t","searchInput":"yft3t"};